// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0401f151","239":"d5c71cbe","732":"fcf69cd8"}[chunkId] + ".chunk.js";
};